import { FnAccordianComponent } from './../fn-accordian.component';
import { FnAccordianPanelContentDirective } from './../fn-accordian-panel-content.directive';
import {
	Component,
	Input,
	TemplateRef,
	Output,
	EventEmitter,
	ViewEncapsulation,
	HostBinding,
	Inject,
	ContentChild,
	ChangeDetectorRef,
	AfterContentInit,
} from '@angular/core';

@Component({
	selector: 'fn-accordian-panel',
	template: `
		<ng-content select="fn-accordian-panel-header"></ng-content>
		<ng-content select=".fn-panel-body"></ng-content>
		<div class="fn-panel-body">
			<ng-container *ngTemplateOutlet="bodyTemplate"> </ng-container>
		</div>
	`,
	encapsulation: ViewEncapsulation.None,
})
export class FnAccordianPanelComponent implements AfterContentInit {
	@Input() opendFnPanelValue = '';

	@Input() fnPanelClass = '';
	@HostBinding('class') class = 'fn-panel ';
	@Output() opened: EventEmitter<string> = new EventEmitter();
	@Output() closed: EventEmitter<boolean> = new EventEmitter();
	@HostBinding('attr.disabled')
	@Input()
	isDisabled: boolean;

	@Input()
	isPanelopen = false;

	bodyTemplate: TemplateRef<void>;

	@ContentChild(FnAccordianPanelContentDirective)
	fnPannelContentTemplate: FnAccordianPanelContentDirective;
	constructor(
		@Inject(FnAccordianComponent) private fnAccordion: FnAccordianComponent,
		private cdr: ChangeDetectorRef
	) {
		this.class = 'fn-panel ' + this.fnPanelClass;
	}
	@HostBinding()
	@HostBinding('class.fn-panel-expend')
	get isOpen(): boolean {
		return this.isPanelopen;
	}

	set isOpen(isPanelOpen: boolean) {
		if (isPanelOpen !== this.isOpen) {
			if (isPanelOpen) {
				this.fnAccordion.closeOtherPanels(this);
				this.opened.emit(this.opendFnPanelValue);
				this.setContent();
			} else {
				this.closed.emit(false);
			}
			this.isPanelopen = isPanelOpen;
		}
	}

	setContent(): void {
		if (this.fnPannelContentTemplate) {
			this.bodyTemplate = this.fnPannelContentTemplate.templateRef;
		}
	}
	ngAfterContentInit() {
		this.setContent();
	}
}
